import * as React from 'react';
import MaskInput, { IInputProps } from 'react-maskinput';
import { CustomInputLabel, CustomModifiedMarker } from '..';
import './CustomMaskedInput.less';

export interface CustomMaskedInputProps extends IInputProps {
    label: string;
    labelTooltip?: string;
    className?: string;
    required?: boolean;
    topRightNode?: React.ReactNode;
    containerStyle?: React.CSSProperties;
    hasError?: boolean;
    disabled?: boolean;
    showModifiedMarker?: boolean;
    getContainerRef?: (containerRef: React.RefObject<HTMLDivElement>) => void;
}

const CustomMaskedInput: React.FC<CustomMaskedInputProps> = (props: CustomMaskedInputProps) => {
    const {
        label,
        labelTooltip,
        required,
        topRightNode,
        containerStyle,
        hasError,
        showModifiedMarker,
        getContainerRef,
        ...inputProps
    } = props;

    const containerRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        if (getContainerRef) {
            getContainerRef(containerRef);
        }
    }, [getContainerRef]);

    const getContainerClassName = () => {
        let className = 'custom-masked-input-container';

        if (hasError) {
            className += ' has-error';
        }

        if (inputProps.disabled) {
            className += ' disabled';
        }

        return className;
    };

    return (
        <div ref={containerRef} className={getContainerClassName()} style={containerStyle}>
            {!!topRightNode && <div className="top-right-node-container">{topRightNode}</div>}

            <MaskInput className={`custom-masked-input ${props.value ? 'not-empty' : ''}`} {...inputProps} />

            <CustomInputLabel label={label} labelTooltip={labelTooltip} required={required} />

            {showModifiedMarker && <CustomModifiedMarker />}
        </div>
    );
};

export default CustomMaskedInput;
